import { PartnersHero } from "./PartnersHero";

export type { PartnersHeroProps } from "./PartnersHero.d";
export { PartnersHero };
